/** Product + provider voice reference audio policy (mirrors backend). */

export const PRODUCT_MIN_DURATION_SECONDS = 20
export const PRODUCT_RECOMMENDED_MIN_SECONDS = 30
export const PRODUCT_RECOMMENDED_MAX_SECONDS = 60

/** Provider contract from MiniMax capability audit — keep in sync with backend. */
export const PROVIDER_MIN_DURATION_SECONDS = 10
export const PROVIDER_MAX_DURATION_SECONDS = 300

export const EFFECTIVE_MIN_DURATION_SECONDS = Math.max(
  PRODUCT_MIN_DURATION_SECONDS,
  PROVIDER_MIN_DURATION_SECONDS,
)
export const EFFECTIVE_MAX_DURATION_SECONDS = PROVIDER_MAX_DURATION_SECONDS

export type VoiceReferenceQualityStatus = 'GOOD' | 'WARNING' | 'BLOCKED'

export type VoiceReferenceFailureCode =
  | 'NO_AUDIO_DATA'
  | 'DECODE_FAILED'
  | 'TOO_SHORT'
  | 'TOO_LONG'
  | 'LOW_VOLUME'
  | 'NO_SPEECH'
  | 'CLIPPING'
  | 'TOO_MUCH_SILENCE'
  | null

export type VoiceReferenceQualityChecks = {
  duration: string
  speech: string
  volume: string
  clipping: string
  format: string
  decode: string
}

export type VoiceReferenceQualityAnalysis = {
  status: VoiceReferenceQualityStatus
  durationMs: number
  blockingReasons: string[]
  warnings: string[]
  checks: VoiceReferenceQualityChecks
  meanRms: number
  peak: number
  silenceRatio: number
  captureOk: boolean
  decodeOk: boolean
  failureCode: VoiceReferenceFailureCode
  speechSeconds?: number
  speechRatio?: number
  sampleRate?: number
  channels?: number
}
